// extracted by mini-css-extract-plugin
module.exports = {"todoContainer":"TodoList_todoContainer__2rxBq"};